module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(490);
	module.exports = __webpack_require__(490);


/***/ },

/***/ 3:
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },

/***/ 478:
/***/ function(module, exports) {

	module.exports = require("./core");

/***/ },

/***/ 490:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(478) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	(function () {

	    // Imports ================================================================
	    var kendo = window.kendo,
	        deepExtend = kendo.deepExtend,
	        defined = kendo.util.defined,
	        g = kendo.geometry;

	    // Constants ==============================================================
	        var GRADIENT = "gradient";
	        var IDENTITY_MATRIX_HASH = g.Matrix.IDENTITY.toString();

	    // Mixins =================================================================
	    var Paintable = {
	        extend: function(proto) {
	            proto.fill = this.fill;
	            proto.stroke = this.stroke;
	        },

	        fill: function(color, opacity) {
	            var options = this.options;

	            if (defined(color)) {
	                if (color && color.nodeType != GRADIENT) {
	                    var newFill = {
	                        color: color
	                    };
	                    if (defined(opacity)) {
	                        newFill.opacity = opacity;
	                    }
	                    options.set("fill", newFill);
	                } else {
	                    options.set("fill", color);
	                }

	                return this;
	            } else {
	                return options.get("fill");
	            }
	        },

	        stroke: function(color, width, opacity) {
	            if (defined(color)) {
	                this.options.set("stroke.color", color);

	                if (defined(width)) {
	                   this.options.set("stroke.width", width);
	                }

	                if (defined(opacity)) {
	                   this.options.set("stroke.opacity", opacity);
	                }

	                return this;
	            } else {
	                return this.options.get("stroke");
	            }
	        }
	    };

	    var Traversable = {
	        extend: function(proto, childrenField) {
	            proto.traverse = function(callback) {
	                var children = this[childrenField];

	                for (var i = 0; i < children.length; i++) {
	                    var child = children[i];

	                    if (child.traverse) {
	                        child.traverse(callback);
	                    } else {
	                        callback(child);
	                    }
	                }

	                return this;
	            };
	        }
	    };

	    var Measurable = {
	        extend: function(proto) {
	            proto.bbox = this.bbox;
	            proto.geometryChange = this.geometryChange;
	        },

	        bbox: function(transformation) {
	            var combinedMatrix = g.toMatrix(this.currentTransform(transformation));
	            var matrixHash = combinedMatrix ? combinedMatrix.toString() : IDENTITY_MATRIX_HASH;
	            var bbox;

	            if (this._bboxCache && this._matrixHash == matrixHash) {
	                bbox = this._bboxCache.clone();
	            } else {
	                bbox = this._bbox(combinedMatrix);
	                this._bboxCache = bbox ? bbox.clone() : null;
	                this._matrixHash = matrixHash;
	            }

	            var strokeWidth = this.options.get("stroke.width");
	            if (strokeWidth && bbox) {
	                bbox.expand(strokeWidth / 2);
	            }

	            return bbox;
	        },

	        geometryChange: function() {
	            delete this._bboxCache;
	            this.trigger("geometryChange", {
	                element: this
	            });
	        }
	    };

	    // Exports ================================================================
	    deepExtend(kendo.drawing, {
	        mixins: {
	            Paintable: Paintable,
	            Traversable: Traversable,
	            Measurable: Measurable
	        }
	    });

	})();

	}, __webpack_require__(3));


/***/ }

/******/ });